export const MAIN_CLASS_NAME = 'run-retry-button';
export const POPOVER_CLASS_NAME = `${MAIN_CLASS_NAME}__popover`;
export const SKELETON_CLASS_NAME = `${MAIN_CLASS_NAME}__skeleton`;
export const RUNS_CLASS_NAME = `${MAIN_CLASS_NAME}__runs`;
export const RUNS_ITEM_CLASS_NAME = `${RUNS_CLASS_NAME}__item`;
export const ATTACHMENTS_CLASS_NAME = `${MAIN_CLASS_NAME}__attachments`;
export const ATTACHMENTS_ITEM_CLASS_NAME = `${ATTACHMENTS_CLASS_NAME}__item`;
export const ATTACHMENTS_FILE_ITEM_CLASS_NAME = `${ATTACHMENTS_ITEM_CLASS_NAME}_file`;
export const ATTACHMENTS_RESOURCE_ITEM_CLASS_NAME = `${ATTACHMENTS_ITEM_CLASS_NAME}_resource`;

export const SKELETON_COUNT = 3;
export const SKELETON_HEIGHT = 16;
export const SKELETON_WIDTH = 468;

export const RUNS_PAGE_SIZE = 30;
